var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyMedViolet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.01172 10.9915C7.33608 11.3227 7.72323 11.5857 8.15051 11.7653C8.57779 11.9449 9.0366 12.0374 9.50006 12.0374C9.96353 12.0374 10.4223 11.9449 10.8496 11.7653C11.2769 11.5857 11.6641 11.3227 11.9884 10.9915L15.9698 7.00906C16.6297 6.34893 17.0005 5.45359 17.0005 4.52003C17.0005 3.58646 16.6297 2.69112 15.9698 2.03099C15.3098 1.37086 14.4147 1 13.4814 1C12.5481 1 11.653 1.37086 10.9931 2.03099L10.4954 2.5288",
    stroke: "#A93DCB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9888 7.00684C10.6644 6.6757 10.2772 6.41263 9.84996 6.23304C9.42268 6.05344 8.96387 5.96094 8.50041 5.96094C8.03694 5.96094 7.57813 6.05344 7.15085 6.23304C6.72358 6.41263 6.33642 6.6757 6.01206 7.00684L2.03071 10.9893C1.37076 11.6494 1 12.5448 1 13.4783C1 14.4119 1.37076 15.3072 2.03071 15.9674C2.69066 16.6275 3.58574 16.9984 4.51905 16.9984C5.45236 16.9984 6.34745 16.6275 7.0074 15.9674L7.50507 15.4696",
    stroke: "#A93DCB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyMedViolet);
export default __webpack_public_path__ + "static/media/copy-med-violet.3d1ee96b542ac16a242250c10a9871d6.svg";
export { ForwardRef as ReactComponent };